module.exports = __webpack_public_path__ + "static/img/about.bab2357.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about.svg
// module id = mj0K
// module chunks = 1